export default "__VITE_ASSET__de23a0ee__"